import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Path = styled.path`
  stroke: var(--color-base-fill);
`;

const LinkIcon = (props) => {
  const { width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M17.445 12.778L19.778 10.445C21.496 8.727 21.496 5.941 19.778 4.222V4.222C18.06 2.504 15.274 2.504 13.555 4.222L11.222 6.555"
        stroke="#3C4852"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.88995 15.11L15.11 8.89001"
        stroke="#3C4852"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.55497 11.222L4.22197 13.555C2.50397 15.273 2.50397 18.059 4.22197 19.778V19.778C5.93997 21.496 8.72597 21.496 10.445 19.778L12.778 17.445"
        stroke="#3C4852"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

LinkIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

LinkIcon.defaultProps = {
  width: 24,
  height: 24
};

export default LinkIcon;
